import {Injectable, Inject} from 'ng-metadata/core';
import {getVid} from '../../../appConfig/appConfigForward';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';


@Injectable()


export class VirtualBrowseItemInfoService {
    private GET_ITEM_API_URL: string;
    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') restBaseURLs,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.GET_ITEM_API_URL= restBaseURLs.pnxBaseURL;
    }
    
    public getItem(docId: string){
        let url = this.GET_ITEM_API_URL +'/' + 'L' + '/' + docId +'?vid=' +
            getVid() + '&lang=' + this.$translate.use()+'&virtualBrowse=true';
        return this.$http.get(url).then((response: any)=>{return new ItemInfo(response.data) });        
    }
        
 
}

export class ItemInfo{
    public _displayLine: string;
    constructor(doc: PrimoResponse.IDoc){
        //TODO parse the response doc and save the data that needs to be displayed
        this._displayLine= doc.pnx.display.title[0];    
    }
    
    get displayLine(): string{
        return this._displayLine;
    }
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowseItemInfo/virtualBrowseItemInfo.service.ts